"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MoveItemInArrayMutate = exports.MoveItemInArrayCopy = exports.GetRoundedMedian = exports.GetRandomItemFromArray = exports.GetMostOccurringBoolean = exports.GetItemIndexWithinArray = exports.BinaryFindInArray = exports.AddAndSortArray = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _numberHelpers = require("./numberHelpers");
// https://stackoverflow.com/questions/20351959/how-to-keep-javascript-array-sorted-without-sorting-it/20352387#20352387

const BinaryFindInArray = (arrayToSearch, searchElement, sortProperty, allowDuplicates) => {
  let minIndex = 0;
  let maxIndex = arrayToSearch.length - 1;
  let currentIndex;
  let currentElement;
  while (minIndex <= maxIndex) {
    // eslint-disable-next-line no-bitwise
    currentIndex = (minIndex + maxIndex) / 2 | 0; // Binary hack. Faster than Math.floor
    currentElement = arrayToSearch[currentIndex];
    if (currentElement[sortProperty] < searchElement[sortProperty]) {
      minIndex = currentIndex + 1;
    } else if (currentElement[sortProperty] > searchElement[sortProperty]) {
      maxIndex = currentIndex - 1;
    } else if (allowDuplicates && currentElement[sortProperty] === searchElement[sortProperty]) {
      return {
        found: true,
        index: currentIndex
      };
    } else {
      return {
        found: true,
        index: currentIndex
      };
    }
  }
  return {
    found: false,
    index: currentElement < searchElement ? currentIndex + 1 : currentIndex
  };
};
exports.BinaryFindInArray = BinaryFindInArray;
const AddAndSortArray = (sourceArray, newElement, sortProperty, allowDuplicates) => {
  const searchResult = BinaryFindInArray(sourceArray, newElement, sortProperty);
  if (!searchResult.found || allowDuplicates) {
    sourceArray.splice(searchResult.index, 0, newElement);
  }
};
exports.AddAndSortArray = AddAndSortArray;
const MoveItemInArrayMutate = (array, fromIndex, toIndex) => {
  const element = array[fromIndex];
  array.splice(fromIndex, 1);
  array.splice(toIndex, 0, element);
  return array;
};
exports.MoveItemInArrayMutate = MoveItemInArrayMutate;
const MoveItemInArrayCopy = (originalArray, fromIndex, toIndex) => {
  const array = [...originalArray];
  const element = array[fromIndex];
  array.splice(fromIndex, 1);
  array.splice(toIndex, 0, element);
  return array;
};

/**
 * Takes an array of items of any shape and returns a random item.
 *
 * @param arrayOfUnknownItems[] arrayOfUnknownItems - The array of items
 * @returns {unknown} a random item from the array
 */
exports.MoveItemInArrayCopy = MoveItemInArrayCopy;
const GetRandomItemFromArray = arrayOfUnknownItems => {
  return arrayOfUnknownItems[(0, _numberHelpers.GetRandomNumberBelow)(arrayOfUnknownItems.length)];
};

/**
 * Takes an array of items of any shape and returns a random item.
 *
 * @param arrayOfUnknownItems[] arrayOfUnknownItems - The array of items
 * @param {unknown} itemToFind - The item to find
 * @returns {number} the index of the item to find within the array
 */
exports.GetRandomItemFromArray = GetRandomItemFromArray;
const GetItemIndexWithinArray = (arrayOfUnknownItems, itemToFind) => {
  return arrayOfUnknownItems.indexOf(itemToFind);
};

/**
 * Takes an array of numbers, finds the min and max and returns a rounded median.
 *
 * @param arrayOfNumbers[] arrayOfNumbers - The array of numbers
 * @returns {number} the rounded median
 */
exports.GetItemIndexWithinArray = GetItemIndexWithinArray;
const GetRoundedMedian = arrayOfNumbers => {
  const min = Math.min.apply(null, arrayOfNumbers);
  const max = Math.max.apply(null, arrayOfNumbers);
  return Math.round((min + max) / 2);
};

/**
 * Takes an array of booleans, finds which boolean occurs the most and returns it.
 *
 * @param arrayOfBooleans[] arrayOfBooleans - The array of booleans
 * @returns {number} the rounded median
 */
exports.GetRoundedMedian = GetRoundedMedian;
const GetMostOccurringBoolean = arrayOfBooleans => {
  const trueCount = arrayOfBooleans.filter(bool => bool === true);
  if (trueCount > arrayOfBooleans.length / 2) {
    return 1;
  }
  return 0;
};
exports.GetMostOccurringBoolean = GetMostOccurringBoolean;